const settings = require(`./_${process.env.NODE_ENV}`);
export default settings;
